export const bookingCharges = {
  header: {
    title: "Cargos",
    titleNew: "Cargos nuevos",
    sub: "Conceptos que se incluirán en la factura del huésped.",
    subNew:
      "Para la próxima factura. El alojamiento ya facturado está arriba, en su factura.",
  },
  loading: "Cargando cargos…",
  empty: {
    title: "Sin cargos registrados",
    titleBilled: "Sin cargos pendientes",
    sub: "Añade alojamiento, limpieza, extras u otros servicios.",
    subBilled: "Añade un cargo para crear otra factura de esta reserva.",
  },
  buttons: {
    addCharge: "Añadir cargo",
    addFirstCharge: "Añadir primer cargo",
    manage: "Gestionar",
    manageTemplatesTitle: "Gestionar plantillas",
    add: "Agregar",
    close: "Cerrar",
    cancel: "Cancelar",
    saving: "Guardando…",
    saveCharge: "Guardar cargo",
    saveChanges: "Guardar cambios",
    deleting: "Eliminando…",
    confirmDelete: "Sí, eliminar",
    editTitle: "Editar",
    deleteTitle: "Eliminar",
  },
  table: {
    item: "Artículo",
    qty: "Cant.",
    unitPrice: "P. Unit.",
    vat: "IVA",
    total: "Total",
  },
  chips: {
    lodging: "Alojamiento",
    discount: "Descuento",
    autoSynced: "Sincronizado automáticamente",
  },
  // Resumen de la estancia bajo cada habitación.
  stay: {
    nights: "1 noche | {n} noches",
    rooms: "1 habitación | {n} habitaciones",
  },

  fields: {
    // De qué habitación es el cargo (reservas de varias habitaciones).
    room: "Habitación",
    roomAll: "Toda la reserva",
    roomHint: "Si es de una habitación concreta, irá en la factura de esa habitación.",
    date: "Fecha",
    category: "Categoría",
    quantity: "Cantidad",
    unitPriceFull: "Precio unitario",
    vatPct: "IVA (%)",
    name: "Nombre",
    price: "Precio",
    internalNotes: "Notas internas",
    paymentMethod: "Método de pago",
    paymentDate: "Fecha de pago",
    guestCount: "Cantidad de huéspedes",
  },
  placeholders: {
    item: "Selecciona o escribe un concepto…",
    egCleaning: "Ej: Limpieza",
    internalNote: "Añadir nota interna…",
  },
  templates: {
    savedTitle: "Cargos guardados",
    noResults: 'Sin resultados para "{query}"',
    emptyPre: "Sin cargos guardados. ",
    createOne: "Crear uno",
    manageTitle: "Cargos personalizados",
    manageSub: "Crea cargos reutilizables para tus facturas.",
    emptyList: "No hay cargos guardados. Añade el primero arriba.",
    noCategory: "Sin categoría",
  },
  vat: {
    labelPct: "IVA {rate}%",
  },
  modal: {
    editTitle: "Editar cargo",
    addSub: "Nuevo concepto para la factura",
    editSub: "Modifica los datos del cargo",
    totalCalculated: "Total calculado",
  },
  common: {
    optional: "(opcional)",
    unspecified: "Sin especificar",
  },
  invoice: {
    sectionLabel: "Factura electrónica",
  },
  footer: {
    pending: "Pendiente de facturar",
    totalDue: "Total a pagar",
  },
  deleteModal: {
    title: "¿Eliminar cargo?",
    sub: "Esta acción no se puede deshacer.",
  },
  autoCategory: {
    service: "Servicio",
    fee: "Cargo",
    extraGuest: "Huésped extra",
    tax: "Impuesto",
    cityTax: "Tasa turística",
    adjustment: "Ajuste",
    autoFallback: "Cargo automático",
  },
  chargeBasis: {
    percentOfTotal: "Porcentaje del total",
    perNight: "Por noche",
    perPerson: "Por persona",
    perPersonPerNight: "Por persona y noche",
    perStay: "Por reserva",
  },
  toast: {
    descRequired: "La descripción es obligatoria.",
    chargeAdded: "Cargo añadido.",
    chargeUpdated: "Cargo actualizado.",
    chargeDeleted: "Cargo eliminado.",
    chargeSaved: "Cargo guardado.",
    saveFailed: "No se pudo guardar.",
    deleteFailed: "No se pudo eliminar.",
    warningTitle: "Atención",
    doneTitle: "Listo",
    errorTitle: "Error",
  },
  invoices: {
    title: "Facturas emitidas",
    noName: "Sin nombre",
    conceptCount: "{count} concepto | {count} conceptos",
    viewPdf: "Ver PDF",
    sendWhatsapp: "Enviar por WhatsApp",
    correct: "Corregir (rectificativa)",
    void: "Anular (rectificativa)",
    conceptsFoot:
      "Estos conceptos ya están facturados. El PDF tiene el detalle completo.",
  },
  status: {
    draft: "Borrador",
    sent: "Emitida",
    processing: "Procesando",
    pending: "Pendiente",
    error: "Error",
    corrected: "Corregida",
    voided: "Anulada",
  },
  checkinModal: {
    title: "Información del registro",
    bookingLink: "Reserva #{code}",
    requestDate: "Fecha de la solicitud: {date} a las {time}",
  },
  payment: {
    desti: "Pago en destino",
    efect: "Efectivo",
    movil: "Pago por móvil",
    otro: "Otros medios de pago",
    platf: "Plataforma de pago",
    tarjt: "Tarjeta de crédito",
    trans: "Transferencia",
    treg: "Tarjeta regalo",
  },
};
